import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formThemeShape } from './PropTypes';

export default class Form extends Component {
  static defaultProps = {
    horizontal: false,
    gray: false,
  };

  static childContextTypes = {
    formTheme: formThemeShape,
  };

  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formik: PropTypes.object,
  };

  getChildContext() {
    const formTheme = {
      horizontal: this.props.horizontal,
      gray: this.props.gray,
    };
    return { formTheme };
  }

  render() {
    const { horizontal, gray, onSubmit, ...props } = this.props;
    const { formik } = this.context;
    return <form {...props} onSubmit={onSubmit || (formik && formik.handleSubmit)} />;
  }
}
